/**
 * Checks to see if window smaller than breakpoint
 * @param {number} breakPoint for component to check
 * @returns {Boolean} returns true if the image has a height or width, otherwise return false
 */
const breakPointChecker = (breakPoint = 1024) => {
  if (typeof window !== 'undefined') {
    return window.matchMedia(`(max-width: ${breakPoint}px)`).matches;
  }

  return false;
};

export {breakPointChecker};



// WEBPACK FOOTER //
// ./src/reactModules/shared/utilities/breakPointChecker.js